module.exports = __webpack_public_path__ + "img/otzarhahayal.43b21409.jpg";